module.exports = __webpack_public_path__ + "static/img/img-3-2.72ea587.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3-2.png
// module id = VKDt
// module chunks = 0